import {
  LinearProgressClasses,
  generateUtilityClasses,
  linearProgressClasses as muiLinearProgressClasses,
} from '@mui/material';

declare module '@mui/material/LinearProgress' {
  interface LinearProgressClasses {
    /**
     * The CSS class applied to the wrapper element that is rendered when the `visibleValue` prop is `true` and the `variant` prop is `'determinate'`.
     */
    wrapper: string;
    /**
     * The CSS class applied to the`role=progressbar` element when the `visibleValue` prop is `true` and the `variant` prop is `'determinate'`.
     */
    visibleValue: string;
    /**
     * The CSS class applied to the label element that displays the progress value as a percentage.
     */
    label: string;
  }
}

const unifyLinearProgressClasses: Pick<
  LinearProgressClasses,
  'wrapper' | 'visibleValue' | 'label'
> = generateUtilityClasses('MuiLinearProgress', [
  'wrapper',
  'visibleValue',
  'label',
]);

const linearProgressClasses: LinearProgressClasses = {
  ...muiLinearProgressClasses,
  ...unifyLinearProgressClasses,
};

export default linearProgressClasses;
